import { InjectionToken } from '@angular/core';

import { IBetslipMessages, ILinearBetslipMessages } from '../models/betslip-messages';

export interface IBetslipMessagesProviderService {
    getMessages(): IBetslipMessages;
}

export interface ILinearBetslipMessagesProviderService {
    getMessages(): ILinearBetslipMessages;
}

export const BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN: InjectionToken<IBetslipMessagesProviderService> =
    new InjectionToken<IBetslipMessagesProviderService>('BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN');

export const LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN: InjectionToken<ILinearBetslipMessagesProviderService> =
    new InjectionToken<ILinearBetslipMessagesProviderService>('LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN');
